import { ACHIEVEMENTS } from '../games/nganya/config/achievements';
import { getVehicle, VEHICLES } from '../games/nganya/config/vehicles';
import type { PlayerProgress } from '../games/nganya/types';
import styles from './Garage.module.css';

interface Props {
  progress: PlayerProgress;
  onSelect: (skinId: string) => void;
  onBack: () => void;
}

export function Garage({ progress, onSelect, onBack }: Props) {
  const selected = getVehicle(progress.selectedSkin);

  return (
    <div className={`stack ${styles.garage}`}>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h2 className="title" style={{ fontSize: '1.55rem' }}>
          Garage
        </h2>
        <button type="button" className="btn btn-ghost" onClick={onBack}>
          Back
        </button>
      </div>
      <p className="muted">Nganya fleet · cosmetics only</p>

      <div className={`panel ${styles.preview}`}>
        <div className={styles.stage} style={{ ['--accent' as string]: selected.accent }}>
          <img
            src={`/${selected.thumbnailPath}`}
            alt={selected.name}
            className={styles.hero}
            draggable={false}
          />
        </div>
        <div className={styles.meta}>
          <span className={styles.rarity} data-rarity={selected.rarity}>
            {selected.rarity}
          </span>
          <strong className={styles.name}>{selected.name}</strong>
          <p className="muted">{selected.description}</p>
        </div>
      </div>

      <div className={styles.carousel} role="list">
        {VEHICLES.map((vehicle) => {
          const unlocked = progress.unlockedSkins.includes(vehicle.id);
          const isSelected = progress.selectedSkin === vehicle.id;
          const unlockLabel =
            ACHIEVEMENTS.find((a) => a.id === vehicle.unlock)?.title ?? vehicle.unlock;
          return (
            <button
              key={vehicle.id}
              type="button"
              role="listitem"
              className={`${styles.card} ${isSelected ? styles.selected : ''} ${!unlocked ? styles.locked : ''}`}
              disabled={!unlocked}
              onClick={() => onSelect(vehicle.id)}
              aria-label={`${vehicle.name}${unlocked ? '' : ' locked'}`}
            >
              <img src={`/${vehicle.thumbnailPath}`} alt="" draggable={false} />
              <span className={styles.cardLabel}>
                <strong>{vehicle.name}</strong>
                <small>{unlocked ? (isSelected ? 'Selected' : 'Tap to select') : unlockLabel}</small>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
